import React from "react";
import classNames from "classnames";
import { Icon } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { InvalidInstructionText } from "./styles_vanilla.css";

export const InvalidInstructionsWarning: React.FC = () => {
  return (
    <p className={classNames("inline-xs", InvalidInstructionText)}>
      <Icon type="exclamation-triangle" color={Colors.WarningDefault} />
      This payment instructions is not valid. Please update this instruction to enable this
      account to receive distribution payments
    </p>
  );
};
